"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivablePlanRequest = void 0;
var ReceivablePlanRequest = /** @class */ (function () {
    function ReceivablePlanRequest() {
    }
    return ReceivablePlanRequest;
}());
exports.ReceivablePlanRequest = ReceivablePlanRequest;
;
//# sourceMappingURL=receivablePlan.request.js.map